import React from 'react'
import Page from '../../components/Page'
import { useLanguageState } from '../../globalStates/LanguageState'
import { useExhibitorDataState } from '../../globalStates/ExhibitorDataState'
import LogoSection from './LogoSection'
import VideoSection from './VideoSection'
import BasicInfoSection from './BasicInfoSection'
import DescriptionSection from './DescriptionSection'
import KeywordsSection from './KeywordsSection'
import SocialMediaSection from './SocialMediaSection'
import ConsentContentSection from './ConsentContentSection'
import FrameSection from './FrameSection'
import { useConfigDataState } from '../../globalStates/ConfigDataState'
import { hasServiceKeys } from '../../globalStates/ConfigDataState'
import CompanySortSection from './CompanySortSection'
import { ProfileSection } from '../../branding/branding'
import MobileHeaderSection from './MobileHeaderSection'

function buildPageTitle(base: string, companyName: string) {
    return `${base} ${companyName}`
}

const ProfilePage: React.FC<{}> = () => {
    const branding = useLanguageState().getStrings()
    const organization = useExhibitorDataState().getOrganization()
    const sectionsOrder = branding.configuration.profilePage.sectionsOrder
    const serviceKeys = useConfigDataState().getServiceKeys()
    const logoVisible = hasServiceKeys(serviceKeys.logo)
    const headerVideoVisible = hasServiceKeys(serviceKeys.headerVideo)
    const headerGraphicVisible = hasServiceKeys(serviceKeys.headerGraphic)
    const socialMediaVisible = hasServiceKeys(serviceKeys.socialMedia)
    const keywordsVisible = hasServiceKeys(serviceKeys.keywords)
    const iframeVisible = hasServiceKeys(serviceKeys.iframe)
    const consentVisible = hasServiceKeys(serviceKeys.consent)

    return (
        <Page
            title={buildPageTitle(branding.configuration.profilePage.pageTitle, organization.name.get())}
            description={branding.configuration.profilePage.pageDescription}
        >
            {sectionsOrder.map((section: ProfileSection, index: number) => {
                switch (section) {
                    case ProfileSection.LOGO: {
                        return (
                            <React.Fragment key={index}>
                                {(logoVisible || headerGraphicVisible) && <LogoSection />}
                            </React.Fragment>
                        )
                    }

                    case ProfileSection.MOBILE_HEADER_IMAGE: {
                        return (
                            <React.Fragment key={index}>
                                <MobileHeaderSection />
                            </React.Fragment>
                        )
                    }

                    case ProfileSection.VIDEO: {
                        return <React.Fragment key={index}>{headerVideoVisible && <VideoSection />}</React.Fragment>
                    }

                    case ProfileSection.BASIC_INFO: {
                        return (
                            <React.Fragment key={index}>
                                <BasicInfoSection />
                            </React.Fragment>
                        )
                    }

                    case ProfileSection.COMPANY_SORT: {
                        return (
                            <React.Fragment key={index}>
                                <CompanySortSection organizationState={organization} />
                            </React.Fragment>
                        )
                    }

                    case ProfileSection.DESCRIPTION: {
                        return (
                            <React.Fragment key={index}>
                                <DescriptionSection />
                            </React.Fragment>
                        )
                    }

                    case ProfileSection.KEYWORDS: {
                        return <React.Fragment key={index}>{keywordsVisible && <KeywordsSection />}</React.Fragment>
                    }

                    case ProfileSection.SOCIAL_MEDIA: {
                        return <React.Fragment key={index}>{socialMediaVisible && <SocialMediaSection />}</React.Fragment>
                    }

                    case ProfileSection.IFRAME: {
                        return <React.Fragment key={index}>{iframeVisible && <FrameSection />}</React.Fragment>
                    }

                    case ProfileSection.CONSENT_CONTENT: {
                        return <React.Fragment key={index}>{consentVisible && <ConsentContentSection />}</React.Fragment>
                    }

                    default:
                        return null
                }
            })}
        </Page>
    );
}

export default ProfilePage
